var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFemale(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u56FE\\u5C42_1",
    "data-name": "\\u56FE\\u5C42 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "07_\u7528\u6237\u5973") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.37,53.43a2,2,0,0,1-1.51,2.15c-2.72.68-9,1.85-19.9,1.85S15.6,56.25,12.85,55.57a2,2,0,0,1-1.5-2.15c.23-2,.9-5.37,2.93-7.34a5.4,5.4,0,0,1,2.2-1.33l.73-.23c5-1.58,9.55-3.16,9.55-4.73v-3a.19.19,0,0,0-.18-.18H26.5a4.75,4.75,0,0,1-1.85.29,13.41,13.41,0,0,1-3.13-.42l-1.21-.38-2.89-.92A.77.77,0,0,1,17.05,34a12.1,12.1,0,0,0,2.73-7.39c0-5,0-13.22,5.23-16.52A13.21,13.21,0,0,1,32.15,8l.72,0h.68a13.31,13.31,0,0,1,7.17,2.05C46,13.36,46,21.61,46,26.57A12.11,12.11,0,0,0,48.68,34a.78.78,0,0,1-.37,1.22l-2.9.91-1.2.38a13.41,13.41,0,0,1-3.13.42,4.91,4.91,0,0,1-1.85-.29h-.07a.19.19,0,0,0-.19.18v3c0,1.57,4.58,3.15,9.54,4.73l.74.23a5.37,5.37,0,0,1,2.19,1.33C53.47,48.06,54.15,51.41,54.37,53.43Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFemale);
export default __webpack_public_path__ + "static/media/female.ce9e25f5.svg";
export { ForwardRef as ReactComponent };